/**
 * Snapshot of the URL query string taken at JS load, before Angular's router
 * runs any redirect (landing-page guard, route redirectTo) that would strip
 * query params from the address bar. Contact-prefill capture reads this so a
 * pre-addressed link's params survive the initial redirect. Captured eagerly at
 * module load and again explicitly from main.ts for deterministic ordering.
 */
let capturedQueryString =
  typeof window !== 'undefined' && window.location ? window.location.search : '';

export function captureInitialQueryString(): void {
  if (typeof window !== 'undefined' && window.location && !capturedQueryString) {
    capturedQueryString = window.location.search;
  }
}

/**
 * Returns the captured query string once, then clears it. One-shot so a later
 * in-session remount of the booking layout at a plain URL (e.g. booking a
 * second meeting via SPA nav, after clearContactPrefill) cannot resurrect the
 * original personalized link's params.
 */
export function consumeInitialQueryString(): string {
  const value = capturedQueryString;
  capturedQueryString = '';
  return value;
}
